import Axios from 'axios';

Axios.defaults.baseURL = 'https://constructionapi.opnie.com/api';
//Axios.defaults.baseURL = 'https://localhost:7035/api';

export const axiosInstance = Axios.create({});
